import { type HTMLAttributes, type ReactNode } from "react";

import { tagStyles, type TagColor } from "#components/shared/tagVariants";

export type ChipColor = TagColor;

/** Props for the Chip component */
export interface ChipProps extends Omit<HTMLAttributes<HTMLSpanElement>, "color"> {
  /** Chip content */
  children: ReactNode;
  /** Optional icon rendered before the content */
  icon?: ReactNode;
  /** Color variant; shares the palette with Tag */
  color?: ChipColor;
  /** Additional class names merged onto the chip */
  className?: string;
}

/**
 * Standalone chip for short status/labels. Shares styling with Tag but does not
 * require a parent TagGroup.
 */
export function Chip({ children, icon, color = "indigo", className, ...props }: ChipProps) {
  return (
    <span
      className={tagStyles({
        color,
        className,
      })}
      {...props}
    >
      {icon ? <span className="mr-0.5 inline-flex items-center">{icon}</span> : null}
      {children}
    </span>
  );
}
